/**
 *  Accordion script file
 **/
import { clientMixin } from '../../mixins/fetch'

export default {
  name: 'Accordion',
  mixins: [clientMixin],
  components: {},
  props: {
    properties: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data: [],
      config: this.properties.config,
      colors: this.properties.config.colors,
      spinner:
        (this.properties.config &&
          this.properties.config.colors &&
          this.properties.config.colors.spinner) ||
        {},
      searcher: undefined,
      selectedColor: this.properties.config.colors[
        this.properties.config.accordionActiveTag
      ],
      activeTag: this.properties.config.accordionActiveTag,
      tagsSpacer: this.properties.config.tagsSpacer,
      windowWidth: window.innerWidth
    }
  },
  async mounted () {
    await this.getQuestions()
  },
  computed: {
    tagButtons () {
      return this.data.reduce((acum, current) => {
        const tag = {
          id: current.id,
          name: current.title,
          color: this.colors[current.id],
          active: this.activeTag === current.id,
          spacer: this.tagsSpacer.includes(current.id)
        }

        acum.push(tag)

        return acum
      }, [])
    },
    tagActive () {
      return this.tagButtons.find(x => x.active)
    },
    currentColor () {
      return this.colors[this.tagActive.id]
    },
    questionsActive () {
      return this.data && this.data.length > 0
        ? this.data.find(x => x.id === this.tagActive.id)
        : null
    },
    questions () {
      if (!this.questionsActive || !this.questionsActive.values) {
        return []
      }

      if (!this.searcher) {
        return this.questionsActive.values
      }
      const regex = new RegExp(this.searcher, 'gi')
      const questions = []

      this.questionsActive.values.forEach(x => {
        const question = {
          ...x
        }

        question.jobs = x.jobs.filter(y => y.title.match(regex))
        questions.push(question)
      })

      return questions
    },
    anyOpen () {
      return this.questions.some(
        x => x.active || (x.jobs || []).some(y => y.active)
      )
    }
  },
  methods: {
    async getQuestions () {
      const { data } = this.properties

      if (!Array.isArray(data) || !data.length) {
        return
      }

      try {
        this.isLoading = true

        const data = await Promise.all(
          this.properties.data.map(async key => {
            try {
              return await this.getData(key)
            } catch (error) {
              return null
            }
          })
        )

        this.data = data.filter(Boolean)
      } catch (error) {
      } finally {
        this.isLoading = false
      }
    },
    toggleTags (button) {
      this.closeAll()
      this.searcher = undefined

      this.activeTag = button.id

      this.idbutton = button.id
      this.$gtm.trackEvent({
        event: 'event_graph', // Event type [default = 'interaction'] (Optional)
        category: 'accordion',
        action: 'select tag',
        label: button.id,
        value: 1,
        noninteraction: false // Optional
      })
    },
    selectTags (tag) {
      this.closeAll()
      this.$refs.selectemployment.close()
      this.$gtm.trackEvent({
        event: 'event_graph', // Event type [default = 'interaction'] (Optional)
        category: 'accordion',
        action: 'select tag',
        label: tag,
        value: 1,
        noninteraction: false // Optional
      })
      this.searcher = undefined
      this.selectedColor = this.properties.config.colors[tag]
      this.activeTag = tag
    },
    toggleQuestion (event, question) {
      if (event) {
        if (!this.idbutton) {
          this.idbutton = this.config.mapActiveTag
        }
        if (this.idbutton === 'jobs' || this.idbutton === 'nodigital') {
          this.labelGtm = 'select ' + this.idbutton + ' category'
        } else {
          this.labelGtm = 'select skill scope'
        }
        this.$gtm.trackEvent({
          event: 'event_graph', // Event type [default = 'interaction'] (Optional)
          category: 'accordion:' + this.idbutton,
          action: this.labelGtm,
          label: question.title,
          value: 1,
          noninteraction: false // Optional
        })
      }
      this.$set(question, 'active', event)
    },
    toggleJob (event, job) {
      if (event) {
        if (!this.idbutton) {
          this.idbutton = this.config.mapActiveTag
        }
        if (this.idbutton === 'jobs' || this.idbutton === 'nodigital') {
          this.labelGtm = 'select ' + this.idbutton + ' profession'
        } else {
          this.labelGtm = 'select skill'
        }
        this.$gtm.trackEvent({
          event: 'event_graph', // Event type [default = 'interaction'] (Optional)
          category: 'accordion:' + this.idbutton,
          action: this.labelGtm,
          label: job.title,
          value: 1,
          noninteraction: false // Optional
        })
      }
      this.$set(job, 'active', event)
    },
    closeAll () {
      Object.values(this.$refs)
        .filter(r => Array.isArray(r))
        .forEach(x => {
          x.forEach(item => {
            item.close()
          })
        })
    },
    clearSearcher () {
      this.searcher = undefined
    }
  }
}
